"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let SidebarTracking = class SidebarTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.sidebar_selected = 'home';
        this.mixpanelHandler = new MixpanelHandler_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    sidebarItemClicked(url) {
        this.$emit('loadView', url);
    }
    trackInMixpanel(m) {
        const originModule = localStorage.getItem('currentModule');
        const destinationModule = m;
        this.mixpanelHandler.trackEvent('switchToModule', {
            origin: 'Switcher',
            from: originModule,
            to: destinationModule,
        });
    }
    switchModuleFromSwitcher(m) {
        this.trackInMixpanel(m);
        const rawModule = { slug: m };
        const targetModule = new Module_1.default(rawModule);
        targetModule.switchToThisModule();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SidebarTracking.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SidebarTracking.prototype, "sidebar_selected", void 0);
SidebarTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Sidebar: bmk_ui_framework_1.Sidebar,
            ModuleSwitcher: bmk_ui_framework_1.ModuleSwitcher,
            SidebarItem: bmk_ui_framework_1.SidebarItem,
            SidebarNavigation: bmk_ui_framework_1.SidebarNavigation,
            ProjectMiniGrid: bmk_ui_framework_1.ProjectMiniGrid,
            Dropdown: floating_vue_1.Dropdown,
            PlusIcon: bmk_ui_framework_1.PlusIcon,
            InstructionsIcon: bmk_ui_framework_1.InstructionsIcon,
            PinIcon: bmk_ui_framework_1.PinIcon,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            FolderIcon: bmk_ui_framework_1.FolderIcon,
            Chart3: bmk_ui_framework_1.Chart3,
        },
    })
], SidebarTracking);
exports.default = SidebarTracking;
